import React from 'react';
import {
  ChatBubbleOutline as MessageCircleIcon,
  Send as SendIcon,
  PersonAdd as UserPlusIcon,
  Person as UserCheckIcon,
} from '@mui/icons-material';
import { T } from '../tokens';
import ActionRow from '../ActionRow';
import KeywordTags from './KeywordTags';

export default function TemplateCardPreview({ template }) {
  const replyLine = (template.replyComment || template.body || '').split('\n')[0] || '(empty)';
  const isCustom = template.templateType === 'custom';
  const isCommentFlow = template.templateType === 'comment_reply' || (
    isCustom && template.triggerChannel === 'instagram_comment'
  );

  const dmValue = isCommentFlow
    ? (template.dmBody?.split('\n')[0] || template.dmLabel || 'Follow-up DM')
    : (template.body?.split('\n')[0] || replyLine);

  const replyValue = isCommentFlow ? replyLine : '—';

  const createLeadValue = template.createLead === false ? 'Disabled' : 'Enabled';
  const assignValue = template.assignAgent || 'Auto';

  return (
    <>
      <KeywordTags
        keywords={template.keywords}
        templateType={template.templateType}
        isSystemDefault={template.isSystemDefault}
        isChannelDefault={template.isChannelDefault}
        triggerChannel={template.triggerChannel}
        emptyLabel={isCustom ? null : null}
      />

      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        marginTop: 14,
        paddingTop: 14,
        borderTop: `1px solid ${T.lineSoft}`,
        gap: '0 12px',
      }}
      >
        <div style={{ minWidth: 0 }}><ActionRow icon={MessageCircleIcon} label="Reply comment" value={replyValue} tint={T.blueSoft} /></div>
        <div style={{ minWidth: 0 }}><ActionRow icon={SendIcon} label="Send DM" value={isCommentFlow ? dmValue : (template.body?.split('\n')[0] || '(empty)')} tint={T.coralSoft} /></div>
        <div style={{ minWidth: 0 }}><ActionRow icon={UserPlusIcon} label="Create lead" value={createLeadValue} tint={T.blueSoft} /></div>
        <div style={{ minWidth: 0 }}><ActionRow icon={UserCheckIcon} label="Assign agent" value={assignValue} tint="#F1F2F5" /></div>
      </div>
    </>
  );
}
